export default {"src":"/_next/static/media/0xbf5140a22578168fd562dccf235e5d43a02ce9b1.f2b8cf86.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};